// Met en forme un nom/prénom : première lettre en majuscule, reste en minuscule,
// y compris après un espace ou un tiret (ex: "JEAN-PIERRE" -> "Jean-Pierre").
export const toDisplayName = (value: string): string =>
  value
    .toLowerCase()
    .replace(/(^|[\s-])([a-zà-ÿ])/g, (_, sep, letter) => sep + letter.toUpperCase());
